// extracted by mini-css-extract-plugin
module.exports = {"videoContainer":"inhouseVideoAd_videoContainer__OWK0d","close":"inhouseVideoAd_close__P9bRf","videoAd":"inhouseVideoAd_videoAd__tRYrU","hidden":"inhouseVideoAd_hidden__F_zpD"};